import React from 'react'
import './PageNotFound.css'

const PageNotFound = () => {
  return (
    <>
      <div className="error-message__container">
        <div className="error-message">404</div>
        <div className="error-message">Page Not Found</div>
      </div>
    </>
  )
}

export default PageNotFound
